import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import ComponentLayout from '../../../src/layouts/component-layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const DoDontContainer = makeShortcode("DoDontContainer");
const Do = makeShortcode("Do");
const Caption = makeShortcode("Caption");
const Dont = makeShortcode("Dont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h2>{`Anatomy`}</h2>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/912236/5072db4b-446f-4091-be35-48cc020d51ba",
        "alt": "An image displaying a testimonial anatomy."
      }}></img></p>
    <ul>
      <li parentName="ul">{`Quote: The quote from the customer.`}</li>
      <li parentName="ul">{`Name: The name of the customer.`}</li>
      <li parentName="ul">{`Position: The position or role of the customer.`}</li>
      <li parentName="ul">{`Avatar or Logo: Optional avatar of the customer or the company logo.`}</li>
    </ul>
    <h2>{`Usage`}</h2>
    <p>{`Use the testimonial component to showcase a quote or a review from a customer. Use the testimonials to build credibility, trust, and provide social proof by displaying customers' sentiments about the product.`}</p>
    <p>{`Testimonials should be short and concise. Quotes should be not be longer than 3-4 lines. Avoid using long quotes that can be hard to understand or that don't provide enough context.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/ca8b16f9-ada6-49b7-a627-db039f5bd3d9" />
    <Caption mdxType="Caption">Use short and concise quotes.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/bb0ae79c-244f-4cdb-83e2-655bd99ee67e" />
    <Caption mdxType="Caption">
      Don't use long quotes that can be hard to read and understand.
    </Caption>
  </Dont>
    </DoDontContainer>
    <p>{`Use highlitghts to alternate the color of the quote mark and emphasize specific parts of the quote.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/0f81c397-c992-41be-8242-4d8500744213" />
    <Caption mdxType="Caption">
      Use emphasis to highlight te beginning of the quote and provide extra
      visual weight.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/107d6fc4-7010-4a7c-859b-6a15b2ad6cc8" />
    <Caption mdxType="Caption">
      Don't use multiple highlights in the same quote to avoid visual noise.
    </Caption>
  </Dont>
    </DoDontContainer>
    <p>{`Avatars and logos are optional and can be used to provide more credibility about the customer or the company. When using an avatar, use an image of the customer to make the testimonial more personal. If an image is not available, use a logo or a similar visual asset that represents the customer company or the organization.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/ed537938-cc59-4d02-9285-878ea03c6f5f" />
    <Caption mdxType="Caption">
      Use a real life image of the customer or the logo of the company.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/6320c943-64e7-4ed3-b337-3734372dcf16" />
    <Caption mdxType="Caption">
      Don't use illustrations or generic images. Use real life images to provide
      trust.
    </Caption>
  </Dont>
    </DoDontContainer>
    <p>{`Testimonials can be used individually or in a group. When using a group of testimonials, use the same size and alignment for all of them. When including an avatar or a logo, use them in all testimonials of the group and keep the same style and size— don't alternate between logos and avatars. We recommend using a maximum of 4 testimonials per group to avoid visual noise and to keep the quotes relevant.`}</p>
    <DoDontContainer stacked mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/fc8eb38a-c765-4730-8c27-98d460d2c03e" />
    <Caption mdxType="Caption">
      Use a maximum of 3 or 4 testimonials per group, with the same size and
      alginment.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/b8b84d81-e71e-4d44-87c7-d227222f2bc7" />
    <Caption mdxType="Caption">
      Don't use different sizes, alignments or alternate avatars and logos for
      groups of testimonials.
    </Caption>
  </Dont>
    </DoDontContainer>
    <p>{`Use a single testimonial to highlight a specific feature or benefit of the product. Use multiple testimonials to showcase each feature when in a list or a `}<a parentName="p" {...{
        "href": "/components/River"
      }}>{`river`}</a>{`.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/e6e233fd-46e1-4d7f-8b07-39bb9169d8d8" />
    <Caption mdxType="Caption">
      Use testimonials to enhance the credibility of an specific feature or
      benefit.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/841d578b-e353-4dee-acbb-5c8bc3e7c356" />
    <Caption mdxType="Caption">
      Don't use multiple testimonials to showcase the same feature to avoid
      visual noise.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h2>{`Options`}</h2>
    <h3>{`Size`}</h3>
    <p>{`The testimonial component uses the small size by default. Use the large size to provide more visual weight.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/3eae1c3c-9a8d-4452-8f3a-a973fa103bd3" />
    <Caption mdxType="Caption">
      Use the large size when using a single, full-width testimonial.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/163324a6-0276-4aa9-94f0-e38d4aea8a3e" />
    <Caption mdxType="Caption">Don't use small size for full-width testimonials.</Caption>
  </Dont>
    </DoDontContainer>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/58036813-77a1-4af6-a2dc-d2ce05ac085d" />
    <Caption mdxType="Caption">
      Use the small size when paired with other components that showcase
      features, like rivers.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/626bae6a-4bdb-42cb-8b82-2f6615f83283" />
    <Caption mdxType="Caption">
      Don't use the large size in small sized areas or components like rivers,
      so they don't conflict with the main content. Even if the quote is short,
      use the small size instead.
    </Caption>
  </Dont>
    </DoDontContainer>
    <DoDontContainer stacked mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/5ac744e5-045c-4acc-8dee-38ebc740a8e4" />
    <Caption mdxType="Caption">Use the small size for single row groups of testimonials.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/ef1e9bdb-2ab8-457f-b54b-ae224c9119c1" />
    <Caption mdxType="Caption">
      Don't use the large size in single row groups, even if the content is
      short. Stack them vertically and use 2 columns instead.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/Pillar"
        }}>{`Pillar`}</a>{`: To display related content with less visual emphasis.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/Card"
        }}>{`Card`}</a>{`: To display navigational related content with higher visual weight.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/River"
        }}>{`River`}</a>{`: To display navigational related content with higher visual weight.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      